export function playSound(soundOn, playSoundFn) {
  if (soundOn && playSoundFn) {
    playSoundFn();
  }
}
